// F03 — Tidslinje som hovedinngang
// Vertikal tidslinje fra 17. juli til 3. august.
// Dagens dag sticky øverst, gårsdagen rett under, fremtidige dager under det.

import { DAYS } from '../data.js';
import { esc } from '../utils.js';
import { getDayWeather, formatBadge } from '../weather.js';

function phaseEm(phase){
  return {
    fly:'✈︎', city:'◐', cruise:'≈', alaska:'⌖', car:'→', mountain:'△'
  }[phase] || '·';
}

function dayRow(day, idx, state){
  // state: 'past' | 'today' | 'future'
  const cls = `fj-day fj-day-${state}`;
  const note = state === 'past'
    ? day._note || ''   // siste dagboknotat hentes inn i senere fase
    : '';
  const meta = day.items && day.items.length
    ? `${day.items.length} punkter`
    : '';
  return `
  <li class="${cls}" onclick="setTab('reisen','plan');setTimeout(()=>document.getElementById('day-${idx}')?.scrollIntoView({behavior:'smooth',block:'center'}),60)">
    <div class="fj-day-rail">
      <span class="fj-day-dot" aria-hidden="true"></span>
    </div>
    <div class="fj-day-body">
      <div class="fj-day-eyebrow">Dag <strong>${idx + 1}</strong> · ${esc(day.d)} · ${esc(day.wd)}</div>
      <div class="fj-day-title">${esc(day.title)}<span class="fj-day-wx" data-tripday="${idx}" aria-hidden="true"></span></div>
      ${meta ? `<div class="fj-day-meta">${esc(meta)}</div>` : ''}
      ${note ? `<div class="fj-day-note">${esc(note)}</div>` : ''}
    </div>
  </li>`;
}

export function renderTimeline(tripDay){
  // tripDay: -1 før reisen, 0–17 underveis
  const total = DAYS.length;

  if(tripDay < 0){
    // Før reisen — kompakt forhåndsvisning: første 4 dager + ... + siste 2
    const preview = [
      ...DAYS.slice(0, 4).map((d, i) => dayRow(d, i, 'future')),
      `<li class="fj-day-gap" aria-hidden="true"><span></span></li>`,
      ...DAYS.slice(-2).map((d, i) => dayRow(d, total - 2 + i, 'future')),
    ];
    return `
    <section class="fj-timeline-wrap">
      <header class="fj-timeline-hdr">
        <h2>Reisens forløp</h2>
        <span class="fj-timeline-meta">${total} dager · Vancouver → Calgary</span>
      </header>
      <ol class="fj-timeline">
        ${preview.join('')}
      </ol>
      <button class="fj-timeline-all" onclick="setTab('reisen','plan')">Se alle ${total} dager →</button>
    </section>`;
  }

  // Underveis — vis gårsdagen, i dag (sticky), neste 3, deretter en gap til sluttdag
  const past = tripDay > 0 ? dayRow(DAYS[tripDay - 1], tripDay - 1, 'past') : '';
  const today = dayRow(DAYS[tripDay], tripDay, 'today');
  const upcoming = DAYS.slice(tripDay + 1, Math.min(tripDay + 4, total))
    .map((d, i) => dayRow(d, tripDay + 1 + i, 'future'))
    .join('');
  const lastIdx = total - 1;
  const tail = tripDay + 4 < lastIdx
    ? `<li class="fj-day-gap" aria-hidden="true"><span></span></li>` + dayRow(DAYS[lastIdx], lastIdx, 'future')
    : '';

  return `
  <section class="fj-timeline-wrap">
    <header class="fj-timeline-hdr">
      <h2>Reisens forløp</h2>
      <span class="fj-timeline-meta">Dag ${tripDay + 1} av ${total}</span>
    </header>
    <ol class="fj-timeline">
      ${past}
      ${today}
      ${upcoming}
      ${tail}
    </ol>
    <button class="fj-timeline-all" onclick="setTab('reisen','plan')">Se hele tidslinjen →</button>
  </section>`;
}

/** Fyll inn vær-badge på alle synlige dagskort. Kalles etter render. */
export async function fillTimelineWeather(){
  const slots = document.querySelectorAll('.fj-day-wx[data-tripday]');
  if (!slots.length) return;
  await Promise.all(Array.from(slots).map(async (el) => {
    const idx = parseInt(el.getAttribute('data-tripday') || '-1', 10);
    if (idx < 0) return;
    const w = await getDayWeather(idx);
    if (!w) return;
    el.textContent = ' · ' + formatBadge(w);
    el.classList.add('fj-day-wx-on');
  }));
}
